import { Component, OnInit } from '@angular/core';
import { GiftCardStepService } from '../../services/giftcard-step.service';
import { Product } from '../../../order/models/product';
import { environment } from '../../../../../environments/environment';
import { ShopSettingsService } from 'src/app/modules/general/services/shop-settings.service';
import { Category } from 'src/app/modules/order/models/category';

@Component({
  selector: 'app-giftcard-list',
  templateUrl: './giftcard-list.component.html',
  styleUrls: ['./giftcard-list.component.css'],
})
export class GiftcardListComponent implements OnInit {

  constructor(
    private giftcardStepService: GiftCardStepService,
    private shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit(): void {
  }

  get giftCardProducts(): Product[] {
    return this.isShowProductImages ? [] : this.giftcardStepService.giftCardProducts;
  }

  onClick(productId: number): void {
    this.giftcardStepService.selectedGiftCardId = productId;
    this.giftcardStepService.forward();
  }

  onProductClick(product: Product): void {
    if (product) {
      this.onClick(product.id);
    }
  }

  local_currency(): any {
    return environment.globalSettings.local_currency;
  }

  get imageGiftCardProducts(): Product[] {
    return this.isShowProductImages ? this.giftcardStepService.giftCardProducts : [];
  }

  get isShowProductImages(): boolean {
    return this.shopSettingsService.shopSettings.isShowProductImages;
  }

  get hideGiftCardProductName(): boolean {
    return this.shopSettingsService.shopSettings.hideGiftCardProductName;
  }

  get categories(): Category[] {
    const groupProductsByCategory = this.shopSettingsService.shopSettings.groupGiftCardsByCategory;
    if (!groupProductsByCategory) {
      return [new Category(0, 'GiftCards')];
    }

    const categories = [];
    const categoriesById = {};

    this.imageGiftCardProducts.forEach(product => {
      if (categoriesById[product.categoryId]) {
        return;
      }

      const category = new Category(product.categoryId, product.categoryName);
      categoriesById[product.categoryId] = category;
      categories.push(category);
    })

    return categories;
  }

  getImageGiftCardProducts(categoryId: number): Product[] {
    if (categoryId === 0) {
      return this.imageGiftCardProducts;
    }

    return this.imageGiftCardProducts.filter(product => product.categoryId === categoryId);
  }

  get showGiftCardsInformationMessage(): boolean {
    return this.shopSettingsService.shopSettings.showGiftCardsInformationMessage
  }
}
